module.exports = __webpack_public_path__ + "static/media/skills-icon.13d9e0a0.svg";